module.exports = __webpack_public_path__ + "img/1.9997d087.png";